import { Dayjs } from 'dayjs';
import 'dayjs/locale/bg';
import 'dayjs/locale/en';

import { BucketUnit } from '../../utils/statistics';

/** Short axis label for a time bucket. */
export const formatBucketLabel = (
  date: Dayjs,
  unit: BucketUnit,
  bucketCount: number,
  locale: string
) => {
  const localized = date.locale(locale);

  if (unit === 'month') {
    return localized.format('MMM');
  }

  // A single week reads best with weekday names
  if (bucketCount <= 7) {
    return localized.format('dd D');
  }

  return localized.format('D.MM');
};

/** Full label for a time bucket, used in tooltips. */
export const formatBucketTitle = (
  date: Dayjs,
  unit: BucketUnit,
  locale: string
) => {
  const localized = date.locale(locale);

  return unit === 'month'
    ? localized.format('MMMM YYYY')
    : localized.format('dddd, D MMMM YYYY');
};

export const formatPercent = (value: number, total: number) =>
  total > 0 ? Math.round((value / total) * 100) : 0;
